import React, { useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import ModalTemplate from './_ModalTemplate';
import SimpleSelect from '../Components/SimpleSelect';
import SimpleTextInput from '../Components/SimpleTextInput';
import ReadOnlyInput from '../Components/ReadOnlyInput';
import { GBENSContext } from '../GBENSContainer';

export const ConsignorDetailsModal = ({ open, setOpen, addNew, setAddNew }) => {
  const modal = 'Consignor';
  const modalLocal = '_' + modal;

  const {
    referenceData,
    errorsLocal,
    setErrorsLocal,
    checkErrorsConsignmentLocal,
    checkErrorsConsignment,
    moveConsignmentData,
    deleteConsignmentData,
    setBlankConsignmentData,
    isReadOnly,
  } = useContext(GBENSContext);

  const [showAlert, setShowAlert] = useState(false);
  const [errorsChecked, setErrorsChecked] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (open && !addNew) {
        moveConsignmentData(modal, modalLocal, false);
        const errors = await checkErrorsConsignmentLocal(modal, true);
        setErrorsLocal(errors);
      } else if (open && addNew) {
        setBlankConsignmentData(modalLocal, addNew);
      }
    };
    run();
  }, [open, addNew]);

  const dontSave = () => {
    setAddNew(null);
    deleteConsignmentData(modalLocal);
    setOpen(false);
    setErrorsLocal(null);
  };
  const save = async () => {
    setAddNew(null);
    const errors = await checkErrorsConsignmentLocal(modal);
    setErrorsLocal(errors);
    if (!errors?.Consignor) setErrorsChecked(true);
  };

  useEffect(() => {
    if (errorsLocal?.Consignor?.modalError) setShowAlert(true);
  }, [errorsLocal]);

  useEffect(() => {
    if (errorsChecked) {
      setShowAlert(false);
      moveConsignmentData(modalLocal, modal, true);
      setOpen(false);
      setErrorsChecked(false);
      setErrorsLocal(null);
      setTimeout(() => {
        checkErrorsConsignment();
      }, 100);
    }
  }, [errorsChecked]);

  const rowProps = {
    leftColumnWidth: '40%',
    rightColumnWidth: '60%',
  };

  return (
    <ModalTemplate
      open={open}
      onClose={() => setOpen(false)}
      title="Trader Details"
      value="Consignor Details"
      body={
        <div>
          {showAlert && (
            <Alert variant="filled" severity="error">
              There are errors with the Consignor
            </Alert>
          )}
          <SimpleSelect
            name="Country"
            screen={screen}
            consignment
            modal={modalLocal}
            id="Country"
            options={referenceData.countryOfOriginCC}
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="EORI*"
            modal={modalLocal}
            consignment
            id="EORI"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Company Name*"
            modal={modalLocal}
            consignment
            id="companyName"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Street Address*"
            modal={modalLocal}
            consignment
            id="streetAddress"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Town / City*"
            modal={modalLocal}
            consignment
            id="townCity"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Postcode*"
            modal={modalLocal}
            consignment
            id="postCode"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
        </div>
      }
      buttons={[
        <Button key={0} onClick={dontSave}>
          Close
        </Button>,
        <Button key={1} onClick={save} disabled={isReadOnly}>
          Add
        </Button>,
      ]}
    />
  );
};

ConsignorDetailsModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  addNew: PropTypes.bool,
  setAddNew: PropTypes.func,
};

export const ConsigneeDetailsModal = ({ open, setOpen, addNew, setAddNew }) => {
  const modal = 'Consignee';
  const modalLocal = '_' + modal;

  const {
    referenceData,
    errorsLocal,
    setErrorsLocal,
    checkErrorsConsignmentLocal,
    moveConsignmentData,
    deleteConsignmentData,
    setBlankConsignmentData,
    checkErrorsConsignment,
    isReadOnly,
  } = useContext(GBENSContext);

  const [showAlert, setShowAlert] = useState(false);
  const [errorsChecked, setErrorsChecked] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (open && !addNew) {
        moveConsignmentData(modal, modalLocal, false);
        const errors = await checkErrorsConsignmentLocal(modal, true);
        setErrorsLocal(errors);
      } else if (open && addNew) {
        setBlankConsignmentData(modalLocal, addNew);
      }
    };
    run();
  }, [open, addNew]);

  const dontSave = () => {
    setAddNew(null);
    deleteConsignmentData(modalLocal);
    setOpen(false);
    setErrorsLocal(null);
  };
  const save = async () => {
    setAddNew(null);
    const errors = await checkErrorsConsignmentLocal(modal);
    setErrorsLocal(errors);
    if (!errors?.Consignee) setErrorsChecked(true);
  };

  useEffect(() => {
    if (errorsLocal?.Consignee?.modalError) setShowAlert(true);
  }, [errorsLocal]);

  useEffect(() => {
    if (errorsChecked) {
      setShowAlert(false);
      moveConsignmentData(modalLocal, modal, true);
      setOpen(false);
      setErrorsChecked(false);
      setErrorsLocal(null);
      setTimeout(() => {
        checkErrorsConsignment();
      }, 100);
    }
  }, [errorsChecked]);

  const rowProps = {
    leftColumnWidth: '40%',
    rightColumnWidth: '60%',
  };

  return (
    <ModalTemplate
      open={open}
      onClose={() => setOpen(false)}
      title="Trader Details"
      value="Consignee Details"
      body={
        <div>
          {showAlert && (
            <Alert variant="filled" severity="error">
              There are errors with the Consignee
            </Alert>
          )}
          <ReadOnlyInput
            value="GB"
            name="Country*"
            id="Country"
            lookup={referenceData.countryOfOriginCC}
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="GB EORI or Trader ID*"
            screen={screen}
            modal={modalLocal}
            consignment
            id="EORI"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
            toolTip="We recommend a GB EORI or a unique reference is entered for the consignee."
          />
          <SimpleTextInput
            name="Company Name*"
            screen={screen}
            modal={modalLocal}
            consignment
            id="companyName"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Street Address*"
            screen={screen}
            modal={modalLocal}
            consignment
            id="streetAddress"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Town / City*"
            screen={screen}
            modal={modalLocal}
            consignment
            id="townCity"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput
            name="Postcode*"
            screen={screen}
            modal={modalLocal}
            consignment
            id="postCode"
            localErrors
            rowProps={rowProps}
            disabled={isReadOnly}
          />
        </div>
      }
      buttons={[
        <Button key={0} onClick={dontSave}>
          Close
        </Button>,
        <Button key={1} onClick={save} disabled={isReadOnly}>
          Add
        </Button>,
      ]}
    />
  );
};

ConsigneeDetailsModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  addNew: PropTypes.bool,
  setAddNew: PropTypes.func,
};

export const ConsignmentDetailsModal = ({ open, setOpen }) => {
  const { saveConsignmentLine, deleteConsignmentLine, referenceData, isReadOnly } = useContext(GBENSContext);
  const save = () => {
    saveConsignmentLine();
    setOpen(false);
  };
  const deleteLine = () => {
    deleteConsignmentLine();
    setOpen(false);
  };

  const rowProps = {
    leftColumnWidth: '35%',
    rightColumnWidth: '65%',
  };

  return (
    <ModalTemplate
      open={open}
      onClose={() => setOpen(false)}
      title="Consignment Details"
      value="Goods Item Number: Line x"
      body={
        <div>
          <SimpleTextInput
            name="Goods Description*"
            item
            id="goodsDescription"
            rowProps={rowProps}
            toolTip="The description must be in English."
            disabled={isReadOnly}
          />
          <SimpleSelect
            name="Type Of Packaging*"
            item
            id="packageType"
            options={referenceData.packageTypes}
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleTextInput name="Packaging Marks*" item id="packagingMarks" rowProps={rowProps} disabled={isReadOnly} />
          <SimpleTextInput name="Number of Packages*" item id="numPackages" rowProps={rowProps} disabled={isReadOnly} />
          <SimpleTextInput name="Number of Pieces*" item id="numPieces" rowProps={rowProps} disabled={isReadOnly} />
          <SimpleTextInput
            name="Gross Weight*"
            weight
            item
            id="grossWeight"
            rowProps={rowProps}
            disabled={isReadOnly}
          />
          <SimpleSelect
            name="UN Dangerous Goods Code"
            item
            id="dangerousGoods"
            options={referenceData.unDangerousGoods}
            rowProps={rowProps}
            placeholder="Select a dangerous goods code (if applicable)"
            disabled={isReadOnly}
            isAutocomplete
            allowUserInputAsValue
          />
        </div>
      }
      buttons={[
        <Button key={0} onClick={deleteLine} disabled={isReadOnly}>
          Delete This Line
        </Button>,
        <Button key={1} onClick={save} disabled={isReadOnly}>
          Save and Close
        </Button>,
      ]}
    />
  );
};

ConsignmentDetailsModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export const InvalidMRNModal = ({ open, setOpen }) => {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Errors detected with the MRN
        </Typography>
        <Typography variant="p" component="p">
          The MRN you have entered could not be linked to a CABIE Declaration
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 3,
          }}
        >
          <Button key={0} onClick={() => setOpen(false)}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

InvalidMRNModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
